import React, { useState, useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Document, Page, pdfjs } from 'react-pdf';
import HTMLFlipBook from 'react-pageflip';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const PdfPageWrapper = React.forwardRef(({ pageNumber, pageWidth, pageHeight }, ref) => (
    <div ref={ref} style={{ width: pageWidth, height: pageHeight, background: 'white', overflow: 'hidden' }}>
        <Page
            pageNumber={pageNumber}
            width={pageWidth}
            renderAnnotationLayer={false}
            renderTextLayer={false}
        />
    </div>
));

const PdfFlipModal = ({ show, onHide, pdfUrl, title }) => {
    const [numPages, setNumPages] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const bookRef = useRef();

    const pageWidth = 370;
    const pageHeight = 520;

    const prevPage = () => bookRef.current?.pageFlip().flipPrev();
    const nextPage = () => bookRef.current?.pageFlip().flipNext();

    const handleHide = () => {
        setNumPages(null);
        setCurrentPage(0);
        onHide();
    };

    return (
        <Modal show={show} onHide={handleHide} size="xl" centered>
            <Modal.Header closeButton style={{ background: '#1a2a4a', color: 'white' }}>
                <Modal.Title style={{ fontSize: '0.9rem', flex: 1 }}>{title}</Modal.Title>
                <a
                    href={pdfUrl}
                    download
                    style={{ fontSize: '0.85rem', color: '#1a2a4a', fontWeight: '700', background: '#ffffff', border: '2px solid #ffffff', borderRadius: '6px', padding: '4px 12px', textDecoration: 'none', marginRight: '8px', whiteSpace: 'nowrap' }}
                >
                    ⬇ Descargar
                </a>
            </Modal.Header>
            <Modal.Body
                style={{
                    background: '#3a3a3a',
                    padding: '24px',
                    minHeight: '600px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '16px',
                }}
            >
                <Document
                    file={pdfUrl}
                    onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                    loading={<p style={{ color: 'white' }}>Cargando PDF...</p>}
                    error={<p style={{ color: '#f88' }}>No se pudo cargar el PDF.</p>}
                >
                    {numPages && (
                        <HTMLFlipBook
                            width={pageWidth}
                            height={pageHeight}
                            ref={bookRef}
                            showCover={false}
                            mobileScrollSupport={true}
                            onFlip={(e) => setCurrentPage(e.data)}
                            style={{ boxShadow: '0 8px 32px rgba(0,0,0,0.5)' }}
                        >
                            {Array.from({ length: numPages }, (_, i) => (
                                <PdfPageWrapper
                                    key={i}
                                    pageNumber={i + 1}
                                    pageWidth={pageWidth}
                                    pageHeight={pageHeight}
                                />
                            ))}
                        </HTMLFlipBook>
                    )}
                </Document>

                {numPages && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        <button onClick={prevPage} style={{ background: '#ffffff', color: '#1a2a4a', fontWeight: '700', border: '2px solid #ffffff', borderRadius: '6px', padding: '6px 16px', cursor: 'pointer', fontSize: '0.9rem' }}>◀ Anterior</button>
                        <span style={{ color: 'white', fontSize: '0.9rem' }}>
                            Página {currentPage + 1} / {numPages}
                        </span>
                        <button onClick={nextPage} style={{ background: '#ffffff', color: '#1a2a4a', fontWeight: '700', border: '2px solid #ffffff', borderRadius: '6px', padding: '6px 16px', cursor: 'pointer', fontSize: '0.9rem' }}>Siguiente ▶</button>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default PdfFlipModal;
